import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

interface NameAndId {
  id: number
  name: string
}

export interface WorkTypes {
  franceWorkTypes?: NameAndId[]
  spainWorkTypes?: NameAndId[]
}

export const getWorkingDayType = (
  contractVersion: ContractVersion,
  availableWorkTypes: WorkTypes
): string | undefined => {
  let workTypes = undefined
  let workTypeId: number | null = null

  if (contractVersion.isFrench) {
    workTypes = availableWorkTypes.franceWorkTypes || []
    workTypeId = contractVersion.attributes.fr_work_type_id
  } else {
    workTypes = availableWorkTypes.spainWorkTypes || []
    workTypeId = contractVersion.attributes.es_working_day_type_id
  }
  if (!workTypes) return undefined

  const workType = workTypes.find((type) => type.id === workTypeId)
  return workType?.name
}
